
$( document ).ready(function() {
	//product description
	function axMarginDescription(){
		if ($('body.template-product .product-single__description-full').length) {
			$('.product-single__description-full h3').each(function( i ) {
				var marginH = $(this).siblings('*:not(h3)').addClass('ax-margin');
				i++
			});
		}  
    }
  
	// axMarginDescription();
 //  //Ajout nb Km fidelite :
 //  	var language = document.querySelector(".disclosure-list__label").innerText;
 //    var ResponsiveLanguage = document.querySelector(".ly-custom-dropdown-current-inner-text").innerText;
 //  	var prix = document.querySelector(".money").innerText;
 //  	var tailles = document.querySelector(".text_popprod");
 //  	var btnpanier = document.querySelector(".ax-add-btn");
 //  	var km = prix.split(",")[0];
  	
  	
 //  	var blocfifi = document.createElement("div");
 //  	blocfifi.classList.add("blocfifi");
  
 //  	var blocfidelite = document.createElement("div");
 //  	blocfidelite.classList.add("blocfidelite");
  
 //  	var kmfidelite = document.createElement("p");
 //  	kmfidelite.classList.add("kmfidelite");
 //  	kmfidelite.classList.add("color");
 //  	kmfidelite.onclick = function() { SmileUI.openPanel();  };
 //  	if(language == "français" || ResponsiveLanguage == 'FR'){
 //      kmfidelite.innerText = "Vous pourriez cumuler "+km+" Km !";
 //    }else if(language == "English" || ResponsiveLanguage == 'EN'){
 //      kmfidelite.innerText = "You can get "+km+" Km!";
 //    }else if(language == "Español" || ResponsiveLanguage == 'ES'){
 //      kmfidelite.innerText = "¡Puedes ganar "+km+" Km!";
 //    }else if(language == "Italiano" || ResponsiveLanguage == 'IT'){
 //      kmfidelite.innerText =  "Potresti accumulare "+km+" Km!";
 //    }else{
 //    	 kmfidelite.innerText = "You can get "+km+" Km!";
 //    }
 //  	var pictokm = document.createElement("img");
 //  	pictokm.classList.add("pictokmimg");
 //  	pictokm.setAttribute("src","https://cdn.shopify.com/s/files/1/0443/6534/9028/files/borneKmRouge.png?v=1655469179");
 //  	pictokm.setAttribute("alt","Kilomètres fidelités");
  
 //  	blocfidelite.appendChild(kmfidelite);
 //  	blocfifi.appendChild(pictokm);
 //  	blocfifi.appendChild(blocfidelite);
  	
  	
 //  	tailles.after(blocfifi);
  
	//slider promo cat home
	if($(window).width() < 767) {
		if ($('body.template-index').length) {
			$(".ax-promo-collection .grid--uniform").slick({
				slidesToShow: 1.15,
				autoplay: true,
				autoplaySpeed: 3500,
				dots: false,
				arrows: false,
				infinite: false
			})
		}
	}

	//module newlsetter ajout class
	if($('#shopify-section-footer .klaviyo-form-TeqRNL').length) {
		setTimeout(function(){
			$('.klaviyo-form-TeqRNL .Button__FormStyledButton-p2mbjt-0').addClass('btn');
		}, 1500);
	}

	if($(window).width() < 767) {
		if ($('.drawer__contents .weglot-container').length) {
			$('.drawer__contents .weglot-container').addClass('appear-animation appear-delay-12');
		}
	}
});


$('.readmore').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'block';
});  

//popup sizeguide
function showPopupprod() {
    var popupContainerprod = $('.popup-container-prod'),
      popupBtnprod = popupContainerprod.find('.popup-btn-prod'),
      templateprod = $('.template-product'),
      popupWrappingprod = $('.wrapping-prod'),
      prodshow = document.getElementById('prod-show');
      
  if(prodshow === null){//gère exceptions si null
  }else{
    prodshow.onclick = function() {
      popupContainerprod.addClass('show-it').removeClass('removed');
      templateprod.addClass('noscroll').removeClass('scroll');  
      popupWrappingprod.addClass('show-it').removeClass('removed');
	};
  }
  if(popupBtnprod === null){
  }else{
  	popupBtnprod.on('click', function() {
      popupContainerprod.removeClass('show-it').addClass('removed');
      templateprod.removeClass('noscroll').addClass('scroll');
      popupWrappingprod.removeClass('show-it').addClass('removed');
    });
  }
    
  if(popupWrappingprod === null){
  }else{
  	popupWrappingprod.on('click', function() {
      popupContainerprod.removeClass('show-it').addClass('removed');
      templateprod.removeClass('noscroll').addClass('scroll');
      popupWrappingprod.removeClass('show-it').addClass('removed');
    });
  }
};

  showPopupprod();

/* Estimer une date de livraison - 
  modifiez les 2 valeurs dateDebut & dateFin - 
  Si ca tombe un samedi ou un dimanche alors ca reporte de 2 ou 1 jour ! */
let dateDebut = 2,
      dateFin = 4,
      livraisonSamedi = "oui";  
  /* Fin - Partie administrable */
  
 let fromDateTimestamp = new Date().getTime() + 24 * dateDebut * 3600 * 1000,      
      fromDateDay = new Date(fromDateTimestamp).getDate(),
      fromDateMonth = new Date(fromDateTimestamp).getMonth() + 1,
      toDateTimestamp = new Date().getTime() + 24 * dateFin * 3600 * 1000,
      toDateDay = new Date(toDateTimestamp).getDate(),       
      toDateMonth = new Date(toDateTimestamp).getMonth() + 1; 
  
      fromDateMonth = (fromDateMonth < 9 ? '0' : '') + fromDateMonth;
      toDateMonth = (toDateMonth < 9 ? '0' : '') + toDateMonth; 
  
  const checkIfWe = day => {   
    if(new Date(fromDateTimestamp).getDay() === 6) {
      if(day !== 1) {        
        fromDateDay = fromDateDay + 2;
        toDateDay = toDateDay + 2;    
      } 
    }   
  } 
livraisonSamedi === "oui" ? checkIfWe(1) : checkIfWe(2);



function deliveryDisplay() {

let preorder = document.querySelector(".gPreorderBtn");
  if(preorder == null){
let language = document.querySelector(".disclosure-list__label").innerText;
let responsiveLanguage = document.querySelector(".ly-custom-dropdown-current-inner-text").innerText;
let blocAddToCart = document.querySelector(".product__alma-payement");
let blocDate = document.createElement("span");

 if(language == "Español" || responsiveLanguage == 'ES'){
        blocDate.innerHTML = `<p class=\"date-livraison color\"style=\"color:black;\"><img src="https://cdn.shopify.com/s/files/1/0443/6534/9028/files/insurance_4_38x38_942f99d9-94f4-48f8-ae74-5459c720e7e6.webp?v=1669643014" style="height:25px;float:left;margin-right:10px;padding-bottom: 3px;"> Fecha estimada de entrega entre <span class="dateColor">${fromDateDay}/${fromDateMonth}</span> y <span class="dateColor">${toDateDay}/${toDateMonth}</span></p>`;
      }else if(language == "Italiano" || responsiveLanguage == 'IT'){
        blocDate.innerHTML = `<p class=\"date-livraison color\"style=\"color:black;\"><img src="https://cdn.shopify.com/s/files/1/0443/6534/9028/files/insurance_4_38x38_942f99d9-94f4-48f8-ae74-5459c720e7e6.webp?v=1669643014" style="height:25px;float:left;margin-right:10px;padding-bottom: 3px;"> Consegna stimata tra le <span class="dateColor">${fromDateDay}/${fromDateMonth}</span> e <span class="dateColor">${toDateDay}/${toDateMonth}</span></p>`;
      }else if(language == "English" || responsiveLanguage == 'EN'){
        blocDate.innerHTML = `<p class=\"date-livraison color\"style=\"color:black;\"><img src="https://cdn.shopify.com/s/files/1/0443/6534/9028/files/insurance_4_38x38_942f99d9-94f4-48f8-ae74-5459c720e7e6.webp?v=1669643014" style="height:25px;float:left;margin-right:10px;padding-bottom: 3px;"> Estimated delivery between <span class="dateColor">${fromDateDay}/${fromDateMonth}</span> and <span class="dateColor">${toDateDay}/${toDateMonth}</span></p>`;
      }else if(language == "français" || responsiveLanguage == 'FR'){
        blocDate.innerHTML = `<p class=\"date-livraison color\"style=\"color:black;\"><img src="https://cdn.shopify.com/s/files/1/0443/6534/9028/files/insurance_4_38x38_942f99d9-94f4-48f8-ae74-5459c720e7e6.webp?v=1669643014" style="height:25px;float:left;margin-right:10px;padding-bottom: 3px;"> Livraison estimée entre le <span class="dateColor">${fromDateDay}/${fromDateMonth}</span> et le <span class="dateColor">${toDateDay}/${toDateMonth}</span></p>`;
      }else{
      	blocDate.innerHTML = `<p class=\"date-livraison color\"style=\"color:black;\"><img src="https://cdn.shopify.com/s/files/1/0443/6534/9028/files/insurance_4_38x38_942f99d9-94f4-48f8-ae74-5459c720e7e6.webp?v=1669643014" style="height:25px;float:left;margin-right:10px;padding-bottom: 3px;"> Estimated delivery between <span class="dateColor">${fromDateDay}/${fromDateMonth}</span> and <span class="dateColor">${toDateDay}/${toDateMonth}</span></p>`;
      }

  
blocDate.classList.add("product__livraison");
blocAddToCart.after(blocDate);

  } else {
    return;
    
  }
}

function datelivraison4sec(){
	setTimeout(deliveryDisplay, 4000);
}

window.onload = function() {
  datelivraison4sec();
 /* blocAlma2sec(); */
}


// fonction pour mettre le bouton 'ajouter au panier' sticky
/*
var windowWidth = $(window).width();

if (windowWidth > 800) {
  $(window).scroll(function(){
  if($(this).scrollTop() > 670) {
    $('.bannerAddToCart').fadeIn();
  } else {
    $('.bannerAddToCart').fadeOut();
  } 
})
}
*/
